import './Footer.scss';

import { memo } from 'react';
import { useLocation } from 'react-router-dom';

import { GAME_ROUTES } from '@/shared/config/constants';

import { FOOTER_TABS } from './footer.config';
import { FooterTab } from './FooterTab';
import { useFooterNavigation } from './useFooterNavigation';

export const Footer = memo(function Footer() {
  const { handleTabClick } = useFooterNavigation();
  const { pathname } = useLocation();
  const isGamePage = GAME_ROUTES.includes(pathname);

  if (isGamePage) return null;

  return (
    <nav className="footer footer--in">
      <div className="footer__inner">
        <div className="footer__nav">
          {FOOTER_TABS.map((tab) => (
            <FooterTab
              key={tab.id}
              tab={tab}
              onClick={(id, active) => handleTabClick(id, active)}
            />
          ))}
        </div>
      </div>
    </nav>
  );
});
